import React, { useState } from "react";
import Navbar from "./Navbar";
import Skills from "./Skills";
import About from "./About";
import Contacts from "./Contacts";
import Projects from "./Projects";
import Introduction from "./Introduction";

const Portfolio = () => {
  const [toggle, setToggle] = useState(false);
  return (
    <>
      <div className="container">
        <div id="home">
          <Introduction toggle={toggle} setToggle={setToggle} />
        </div>
        <div id="about">
          <About />
        </div>
        <div id="skills">
          <Skills />
        </div>
        <div id="projects">
          <Projects />
        </div>
        <div id="contacts">
          <Contacts />
        </div>
        <Navbar toggle={toggle} setToggle={setToggle} />
      </div>
    </>
  );
};

export default Portfolio;
